module.exports = __webpack_public_path__ + "img/margot-majuscules.e63eac86.jpg";